"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoTitle = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../utils/constants");
var _hooks = require("../../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const InfoTitle = _ref => {
  let {
    componentId,
    type
  } = _ref;
  const tv = (0, _paulCorePackage.useTranslationValue)();
  const {
    MANUFACTURER_UNKNOWN,
    MODEL_UNKNOWN
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  const component = (0, _hooks.useGetComponentByTypeAndId)({
    type,
    id: componentId
  }) || {};
  const {
    thingHtgSubLocalHeatingType
  } = component;
  const componentTitleParts = _constants.configComponentTitle[type].map(title => "".concat(tv(component[title]) || ''));
  const manufactureTitle = componentTitleParts[0];
  const modelTitle = componentTitleParts[1];
  const showIfNotHtgSubDirect = Number(thingHtgSubLocalHeatingType === null || thingHtgSubLocalHeatingType === void 0 ? void 0 : thingHtgSubLocalHeatingType.id) !== _constants.thingHtgSubLocalHeatingTypes.direct;
  if (!manufactureTitle && showIfNotHtgSubDirect) {
    return /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "h5",
      sx: {
        color: _constants.colors['main-color-cl-15']
      }
    }, MANUFACTURER_UNKNOWN);
  }
  if (!modelTitle && showIfNotHtgSubDirect) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      gap: 1,
      component: "h5"
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "span",
      sx: {
        fontSize: '32px'
      }
    }, tv(modelTitle), " -"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "span",
      sx: {
        fontSize: '32px',
        color: _constants.colors['main-color-cl-15']
      }
    }, MODEL_UNKNOWN));
  }
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    component: "h5",
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "span",
    sx: {
      fontSize: '32px'
    }
  }, tv(manufactureTitle), " ", tv(modelTitle)));
};
exports.InfoTitle = InfoTitle;
InfoTitle.propTypes = {
  componentId: _propTypes.default.string,
  type: _propTypes.default.oneOf([...Object.values(_paulCorePackage.constants.ComponentTypes), 'Burner'])
};